export const toSlug = (name = '') =>
  name.toLowerCase().replace(/['']/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const fmt = (n) => n != null ? `₹${Number(n).toFixed(0)}` : '';
